import { connect } from 'react-redux'
import { reduxForm, formValueSelector, isInvalid } from 'redux-form'

import COMPANY_RULES from '../validation/validationRules/company'
import { getValidationRules } from '../validation/validation'
import { getAllCompanies } from './selectors/companySelectors'
import { COMPANY_SIZES, INDUSTRIES, COUNTRIES } from '../constants/companyConstants'
import CompanyFormComponent from '../components/profile/Company/CompanyFormComponent'
import { addCompany, editCompany } from '../store/actions/companies'

const _ = require('lodash');

export const checkForOtherFields = (state, selector) => {
    const showOtherIndustryField = selector(state, 'industry') === 'Other'
    const showOtherVerticalField = selector(state, 'vertical') === 'Other'
    const showVerticalField = selector(state, 'industry') === 'Fitness'

    return {
        otherFields: {
            industry: showOtherIndustryField,
            vertical: showOtherVerticalField,
            isFitnessIndustry: showVerticalField,
        },
    }
}

const mapDispatchToProps = {
    addCompany,
    editCompany,
};

const mergeProps = (
    { companies, company, close, ...stateProps },
    { addCompany, editCompany },
) => {
    let prevData = {};
    return {
        ...stateProps,
        onSubmit: (data) => {
            if (!_.isEqual(data, prevData)) {
                prevData = data;

                let promise;

                if (company) {
                    promise = editCompany(data, companies);
                } else {
                    promise = addCompany(data);
                }

                return promise.then(close).finally(() => {
                    prevData = {};
                });
            }
        },
    }
};

const selector = formValueSelector('newCompany')
const mapStateToProps = (state, { history, company, close, initialValues, updateInvalid }) => ({
    ...checkForOtherFields(state, selector, history),
    company,
    close,
    initialValues,
    companies: getAllCompanies(state),
    isInvalid: isInvalid('newCompany')(state),
    updateInvalid,
});

export const validationRules = [
    'name',
    'platform',
    'companySize',
    'industry',
    'otherIndustry',
    'vertical',
    'otherVertical',
    'country',
    'address',
    'city',
    'state',
    'postalCode',
]

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(reduxForm({
    form: 'newCompany',
    validate: getValidationRules(validationRules, COMPANY_RULES),
    initialValues: {
        companySize: COMPANY_SIZES[0],
        industry: INDUSTRIES[0],
        country: COUNTRIES[0],
    },
})(CompanyFormComponent))



// WEBPACK FOOTER //
// ./src/containers/CompanyFormContainer.js